import { LcarsPanel } from '../layout/LcarsPanel';

const SOURCES = [
  { name: 'TechCrunch AI', time: '12m ago' },
  { name: 'EC Press Corner', time: '1h ago' },
  { name: 'NIST News', time: '2h ago' },
];

export function SourcesPanel() {
  return (
    <LcarsPanel color="var(--lilac)" title="Sources">
      <div class="source-list">
        {SOURCES.map((src) => (
          <div class="src-row" key={src.name}>
            <div class="src-dot"></div>
            <div class="src-name">{src.name}</div>
            <div class="src-time">{src.time}</div>
          </div>
        ))}
      </div>
    </LcarsPanel>
  );
}
